import { useMemo } from "react";
import {
  AutoRecipeDefaultsRead,
  AutoRecipeParameterScope,
} from "store/api/generatedApi";
import { useAutoRecipeDraft } from "components/defaultParameters/useAutoRecipeDraft";
import { useAutoRecipeValidation } from "./useAutoRecipeValidation";

export const useAutoRecipeEditor = ({
  defaults,
  scope,
}: {
  defaults: AutoRecipeDefaultsRead;
  scope: AutoRecipeParameterScope;
}) => {
  const draft = useAutoRecipeDraft(defaults);
  const candidate = useMemo(
    () => ({ context: draft.source.context, parameters: draft.draft }),
    [draft.source.context, draft.draft]
  );
  const validation = useAutoRecipeValidation(
    candidate,
    draft.source.definition,
    scope
  );
  return { ...draft, ...validation };
};
